/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyCountryKey, ShopifyProvinceKey, ShopifyProvinceToCountryKey, ShopifyProvinceToShopKey, ShopifyShopKey } from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProvinceKey,
  "2022-01": {
    name: "Shopify Province",
    fields: [
      {
        name: "Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "code" } },
      },
      {
        name: "Country",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProvinceToCountryKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_id" } },
        configuration: {
          relatedModelKey: ShopifyCountryKey,
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      // TODO: Depends on Shipping Zone model
      // {
      //   name: "Shipping Zone",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyProvinceToShippingZoneKey,
      //   contributorConfiguration:  { [ShopifyDominion.id]: {shopifyFieldKey: "shipping_zone_id" }},
      //   configuration: {
      //     relatedModelKey: ShopifyShippingZoneKey,
      //   },
      // },
      {
        name: "Tax",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax" } },
      },
      {
        name: "Tax Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_name" } },
      },
      {
        name: "Tax Percentage",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_percentage" } },
      },
      {
        name: "Tax Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tax_type" } },
        configuration: {
          allowMultiple: false,
          options: [{ name: "normal" }, { name: "harmonized" }, { name: "compounded" }],
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProvinceToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "country" },
  },
  "2025-04": {
    isDisconnected: true,
  },
};

export const ShopifyProvince = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
